import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Loader2, AlertTriangle, X } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function DamageCharge({ booking, token, onSaved }) {
  const [open, setOpen] = useState(false);
  const [desc, setDesc] = useState("");
  const [amount, setAmount] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    const amt = parseFloat(amount);
    if (!amt || amt <= 0) { toast.error("Enter a charge amount greater than $0."); return; }
    setBusy(true);
    try {
      const { data } = await axios.post(`${API}/bookings/${booking.id}/charge-damage`, { description: desc, amount: amt }, { headers: { Authorization: `Bearer ${token}` } });
      toast.success(`$${data.charged} added to balance${data.emailed ? " & pay link emailed" : ""}.`);
      setOpen(false); setDesc(""); setAmount("");
      onSaved?.();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Could not add charge.");
    } finally {
      setBusy(false);
    }
  };

  if (!open) {
    return (
      <button data-testid={`damage-charge-btn-${booking.id}`} onClick={() => setOpen(true)}
        className="text-xs flex items-center gap-1.5 border border-red-500/40 text-red-400 px-3 py-1.5 rounded hover:bg-red-500 hover:text-white transition-colors">
        <AlertTriangle size={13} /> Charge for Damage
      </button>
    );
  }
  return (
    <div data-testid={`damage-charge-form-${booking.id}`} className="w-full mt-2 rounded-lg border border-red-500/30 bg-[#0A0A0A] p-3 space-y-2">
      <div className="flex items-center justify-between">
        <span className="text-sm font-semibold text-red-400 flex items-center gap-1.5"><AlertTriangle size={14} /> Damage / Incident Charge</span>
        <button onClick={() => setOpen(false)} className="text-white/40 hover:text-white"><X size={16} /></button>
      </div>
      <input data-testid={`damage-desc-${booking.id}`} value={desc} onChange={(e) => setDesc(e.target.value)} placeholder="What happened? (e.g. cracked windshield)" className="w-full bg-[#0C0C0C] border border-white/10 rounded px-3 py-2 text-sm text-white placeholder:text-white/30 focus:outline-none focus:border-red-500/50" />
      <div className="flex gap-2">
        <input data-testid={`damage-amount-${booking.id}`} type="number" step="0.01" value={amount} onChange={(e) => setAmount(e.target.value)} placeholder="Amount $" className="flex-1 bg-[#0C0C0C] border border-white/10 rounded px-3 py-2 text-sm text-white placeholder:text-white/30 focus:outline-none focus:border-red-500/50" />
        <button data-testid={`damage-submit-${booking.id}`} onClick={submit} disabled={busy} className="bg-red-500 text-white font-semibold text-sm px-4 py-2 rounded hover:bg-red-600 transition-colors disabled:opacity-60 flex items-center gap-1.5">
          {busy && <Loader2 className="animate-spin" size={14} />} Charge & Email
        </button>
      </div>
      <p className="text-white/35 text-xs">Adds to the renter's balance and emails them a secure pay link.</p>
    </div>
  );
}
